import { useRecoilValue } from 'recoil';
import { DvfField, DvfProbe, dvfProbeAt } from '~/domain/dvf/dvfField';
import { useEnvironmentShowing } from '~/hooks/environment/useEnvironmentShowing';
import { useSelectedPrimaryImage } from '~/hooks/image/useSelectedImages';
import { usePlaneRedrawTick } from '~/hooks/viewer/annotationOverlay';
import { viewManagerState } from '~/state/atoms/engineAtoms';

const CROSSHAIR_EVENTS: readonly string[] = ['planeIntersectionPointChanged'];

export type DvfCursorProbe =
    | { status: 'no-view' }
    | { status: 'outside' }
    | { status: 'inside'; probe: DvfProbe };

export function useDvfCursorProbe(field: DvfField): DvfCursorProbe {
    const viewManager = useRecoilValue(viewManagerState);
    // The field is in the primary image's frame, so its crosshair is the one probed.
    const environment = useEnvironmentShowing(useSelectedPrimaryImage());
    // The crosshair moves by mutating the view; the tick is what re-renders.
    usePlaneRedrawTick(viewManager, CROSSHAIR_EVENTS);

    if (!environment) {
        return { status: 'no-view' };
    }
    const probe = dvfProbeAt(
        field,
        environment.planeIntersectionPoint.coordinates
    );
    return probe ? { status: 'inside', probe } : { status: 'outside' };
}
